module.exports = __webpack_public_path__ + "static/media/calendar.ce0b5624.svg";